export interface IContactState {
    loading: boolean;
    success: boolean;
    error: string | null;
}

export const initialState: IContactState = {
    loading: false,
    success: false,
    error: null
};

export enum ACTION_TYPES {
    SET_LOADING = 'SET_LOADING',
    SET_SUCCESS = 'SET_SUCCESS',
    SET_ERROR = 'SET_ERROR',
    RESET_STATE = 'RESET_STATE',
}

export interface IContactAction {
    type: ACTION_TYPES;
    payload?: any;
}

export const contactReducer = (state: IContactState, action: IContactAction): IContactState => {
    switch (action.type) {
        case ACTION_TYPES.SET_LOADING:
            return { ...state, loading: action.payload, error: null };
        case ACTION_TYPES.SET_SUCCESS:
            return { ...state, success: action.payload, loading: false, error: null };
        case ACTION_TYPES.SET_ERROR:
            return { ...state, error: action.payload, loading: false, success: false };
        case ACTION_TYPES.RESET_STATE:
            return initialState;
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
